import { useState } from "react";
import DataTable from "../components/DataTable";
import Page from "../components/Page";
import TableActions from "../components/TableActions";
import { useHistory } from "react-router-dom";
import { useUserProvider } from "../providers/UserProvider";

import { DisableApp, DisableScopedApp, GetAppResource } from "../services/api/app";
import { useModalProvider } from "../providers/ModalProvider";
import { DeleteCategory } from "../services/api/category";
// import { CloneItem } from "../services/api/clone";

const Categories = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { showModal, closeModal } = useModalProvider();

  const [data, setData] = useState({
    loading: false,
    data: [],
    count: 0,
  });

  const history = useHistory();

  const { user } = useUserProvider();


  const loadData = async () => {
    setData({ ...data, loading: true });
    GetAppResource(user, "categories")
      .then((res) => res.json())
      .then((jsonData) => {
        setData({
          loading: false,
          data: jsonData.data,
          count: jsonData.data.length,
        });
      });
  };


  const links = [
    { name: "Home", url: "/" },
    { name: "Categories", url: "/categories" },
  ];

  const metadata = [
    {
      name: "sort_order",
      label: "Sort Order",
      parser: (data) => data.sort_order,
    },
    {
      name: "name",
      label: "Category Name",
      parser: (data) => data.name,
      ellipsis: true,
    },
    {
      name: "tags",
      label: "Tags",
      parser: (data) => data?.tags?.map(tag => tag.name).join(", "),
      ellipsis: true,
    },
    {
      name: "toMenu",
      label: "Add to Menu",
      parser: (data) => (data.active ? "Yes" : "No"),
      ellipsis: true,
    },

    {
      name: "actions",
      label: "Actions",
      parser: (data) => (
        <TableActions
          onUpdateClick={updateButtonHandler}
          item_id={data.id}
          onDeleteClick={() => {
            showModal(
              <div>
                <div>Are you sure you want to delete this Category?</div>
                <div className="flex flex-row items-center gap-3 mx-auto justify-center">
                  <button
                    className="ttnk-button mt-2"
                    onClick={() => {
                      const disableAction = () => DeleteCategory(data.id, user.idToken)

                      disableAction().then(() => {
                        closeModal();
                        loadData();
                      });
                    }}
                  >
                    Yes
                  </button>
                  <button className="ttnk-button mt-2" onClick={closeModal}>
                    Cancel
                  </button>
                </div>
              </div>
            );
          }}
        />
      ),
    },
  ];

  const AddButton = () => {
    return (
      <button
        className="ttnk-button add-button"
        onClick={() => history.push("/categories/new")}
      >
        Add Category
      </button>
    );
  };

  const updateButtonHandler = (id) => {
    history.push(`/categories/${id}`);
  };



  return (
    <Page
      links={links}
      title="Categories"
      titleComponent={AddButton()}
    >
      <DataTable
        metadata={metadata}
        dataLoader={loadData}
        data={data}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
        searchKeys={["name"]}
      />
    </Page>
  );
};

export default Categories;
